import { Text, Grid } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { api } from "../../services/api";
import { CityContext } from '../../Context/CityContext';
import { useLocation } from 'react-router-dom';
import { FilterChip } from "../FilterChip";

const kitTypeOptions = ["Kit Empresa", "Kit Verão"];

export function KitFilters(props) {
  const location = useLocation();
  const [kitTypes, setKitTypes] = useState([]);
  const { cityParam } = useContext(CityContext);

  async function filterProducts(types) {
    let url = `/api/v1/products?city_id=${cityParam}`;
    if (types.length > 0) {
      url += `&kit_types=${types.join(',')}`;
    } else {
      const filter = new URLSearchParams(location.search).get("filter");
      if (filter) url += `&filter=${filter}`;
    }
    const response = await api.get(url);
    props.setProducts(response.data.products);
  }

  function toggleType(type) {
    const updated = kitTypes.includes(type) ? kitTypes.filter(t => t !== type) : [...kitTypes, type];
    setKitTypes(updated);
    filterProducts(updated);
  }

  return (
    <>
      <Text fontSize="11px" fontWeight="800" color="rgba(0,74,51,0.55)" letterSpacing="0.08em" textTransform="uppercase" mb="10px">
        Tipos
      </Text>
      <Grid templateColumns="repeat(2,1fr)" gap="8px">
        {kitTypeOptions.map((t, i) => (
          <FilterChip key={i} label={t} isActive={kitTypes.includes(t)} onClick={() => toggleType(t)} />
        ))}
      </Grid>
    </>
  );
}
